<template>
  <div class="footer">
    <b-container>
      <div class="left">
        <img src="@/assets/images/footer/d-up-we-hustle-different.png" />
      </div>
      <div class="right">
        <h1>Thank&nbsp;you</h1>
        <p>
          Whether this was your first season, or you've been with us since 1957,
          as a valued member of the Pistons One family, you are what motivates
          us to entertain, inspire, and unite by winning the right way. Thank
          you for your continued support, passion, and commitment to the Detroit
          Pistons Organization.
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 55px 0 54px 0;
  width: 100%;
  // background-image: url("~@/assets/images/footer/thank-you-bg.jpg");
  background-image: url("~@/assets/images/intro/our-city-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  @media (min-width: 992px) {
    background-attachment: fixed;
  }
  @media (max-width: 767px) {
    padding: 61px 0 81px 0;
  }
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 133px;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 69px;
    }
    .left {
      img {
        width: 200px;
        object-fit: contain;
        @media (max-width: 767px) {
          width: 180px;
          max-width: 75%;
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      h1 {
        font-family: Birdrockers;
        font-size: 52px;
        line-height: 52px;
        letter-spacing: normal;
        color: #ffffff;
        margin-bottom: 23px;
        @media (max-width: 767px) {
          font-size: 42px;
          line-height: 42px;
        }
      }
      p {
        font-family: DINPro;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: normal;
        color: #ffffff;
        margin: 0;
      }
    }
  }
}
</style>
